var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_content"},[(_vm.activity && _vm.activity.custom_bg === 2)?_c('img',{staticClass:"home_bg",attrs:{"src":_vm.activity.custom_image,"alt":""}}):_c('img',{staticClass:"home_bg",attrs:{"src":require("@/assets/home/bg.png"),"alt":""}}),_c('div',{staticClass:"home_content_box"},[_c('Header'),(
        _vm.activity.douyin_switch ||
        _vm.activity.xhs_switch ||
        _vm.activity.kuaishou_switch ||
        _vm.activity.daijia_switch
      )?[_c('ModuleOne',{on:{"openCover":_vm.openCover,"CallForAChauffeur":_vm.CallForAChauffeur,"releaseKs":_vm.releaseKs}})]:_vm._e(),(
        _vm.activity.dianping_switch ||
        _vm.activity.poi_switch ||
        _vm.activity.gaode_switch ||
        _vm.activity.xiecheng_switch
      )?[_c('ModuleTwo',{on:{"openCover":_vm.openCover,"openPopup":_vm.openPopup}})]:_vm._e(),(
        _vm.activity.home_switch ||
        _vm.activity.wechat_switch ||
        _vm.activity.shipinhao_switch
      )?[_c('ModuleThree',{on:{"openCover":_vm.openCover}})]:_vm._e(),(
        _vm.activity.meituan_switch ||
        _vm.activity.friend_switch ||
        _vm.activity.mini_program_switch
      )?[_c('ModuleFour',{on:{"openCover":_vm.openCover,"openPopup":_vm.openPopup}})]:_vm._e(),(
        _vm.activity.share_switch ||
        _vm.activity.act_switch ||
        _vm.activity.wifi_switch ||
        _vm.activity.xhs_follow_switch ||
        _vm.activity.xhs_image_switch ||
        _vm.activity.custom_url_switch
      )?[_c('ModuleFive',{on:{"openCover":_vm.openCover}})]:_vm._e(),(_vm.activity.wifi_switch)?[_c('Wifi',{on:{"openCover":_vm.openCover}})]:_vm._e(),(_vm.activity.set_meal_switch && _vm.activity.set_meal)?[_c('ModuleSix',{on:{"openCover":_vm.openCover}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }